import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { useEffect } from 'react';
import { getAuthAccessToken } from '../Authentication/ApplicationAuthentication';
export function useSignalR(props) {
    useEffect(function () {
        var connection = new HubConnectionBuilder()
            .withUrl(props.endPointUrl + "hub", {
            accessTokenFactory: getAuthAccessToken
        })
            .configureLogging(LogLevel.Warning)
            .build();
        connection.on(props.endPointHub, function (newObject) {
            console.log("SignalR (groupName: " + props.endPointGroupName + ", hub: " + props.endPointHub + ") - responded item: ", newObject);
            props.onSignalResponse(newObject);
        });
        connection.start().then(function () {
            return connection.invoke('AddToGroup', props.endPointGroupName);
        });
        return function () {
            connection.invoke('RemoveFromGroup', props.endPointGroupName).then(function () {
                return connection.stop();
            });
        };
    }, []);
}
